<ll-titulo>Evaluaciones masivas</ll-titulo>

<p>
    Evaluaciones que pueden ser contestadas por cualquier estudiante de la plataforma (incluyendo evaluaciones masivas,
    ensayos mensuales, etc.):
</p>
<br />
<admin-evaluaciones-masivas></admin-evaluaciones-masivas>
